import { Button, Col, Modal, Row, Text } from 'components';
import { useTranslation } from 'react-i18next';

const PaymentModal = ({ visible, closeModal, navigate, athleteId, athleteName, cta }) => {
  const { t } = useTranslation();

  function navigateToPayment(navigate) {
    if (cta === 'subscribe') {
      navigate && navigate(`/billing?athleteId=${athleteId}&cta=${cta}`);
    } else {
      navigate && navigate(`/billing?cta=${cta}&athleteName=${athleteName}&athleteId=${athleteId}`);
    }
  }

  // const ctaLabel = cta?.toLowerCase() === 'face2face' ?  t('common.oneOnOnes') : cta;

  return (
    <Modal visible={visible} closeModal={closeModal}>
      <Col pad="64px" center wid="100%" maxWid="400px" marg="0 auto" boxSizing="border-box">
        <Col centerAll wid="100%">
          <Text h3 center>
            {t('billing.addPaymentMethod')}
          </Text>

          <Row maxWid="296px" style={{ justifyContent: 'center', marginTop: '16px' }}>
            <Text center marg="18px 0 0">
              {t('billing.youNeedToAddMethod')}
              {/* {ctaLabel ? ` for ${ctaLabel}.` : ''} */}
            </Text>
          </Row>
        </Col>

        {/* Buttons on the same row */}
        <Row marg="30px 0 0" display="flex" justifyContent="space-between" gap="12px">
          <Button
            big
            text={t('common.addNew')}
            onClick={() => navigateToPayment(navigate)}
            style={{
              width: '48%', // Adjust width to fit both buttons in a row
              backgroundColor: 'red', // Red background for the "Add New" button
              borderColor: 'red', // Red border for the button
              color: '#fff' // White text for contrast
            }}
          />

          <Button
            big
            bordered
            text={t('common.cancel')}
            onClick={closeModal}
            style={{
              width: '48%' // Adjust width to fit both buttons in a row
            }}
          />
        </Row>
      </Col>
    </Modal>
  );
};

export default PaymentModal;
